import { render, staticRenderFns } from "./AMSBrandSelector.vue?vue&type=template&id=21242808&scoped=true&"
import script from "./AMSBrandSelector.vue?vue&type=script&lang=ts&"
export * from "./AMSBrandSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AMSBrandSelector.vue?vue&type=style&index=0&id=21242808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21242808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout,VList,VListTile,VListTileTitle,VMenu,VProgressCircular,VTextField})
